import { render, staticRenderFns } from "./titulos.vue?vue&type=template&id=6b132370&scoped=true&"
import script from "./titulos.vue?vue&type=script&lang=js&"
export * from "./titulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b132370",
  null
  
)

export default component.exports